import type { CheckpointLocales } from '@/types/lang/locales'

export const checkpointsEn: CheckpointLocales = {
    actions: {
        eraseDetections:
            'Re-initializing reads will erase each read currently saved. Are you sure ?',
        eraseDetectionsTitle: 'Re-initialize reads',

        reassignDevice: 'Do you want to reassign device {device} to POI {checkpoint} ?',
        reassignDeviceTitle: 'Reassign device'
    },
    api: {
        error: {
            createCheckpoint: 'An error occured while creating the POI {name}',
            deleteCheckpoint: 'An error occured while deleting the POI {name}',
            fetchCheckpoint: 'An error occured while fetching the POI',
            fetchCheckpoints: 'An error occured while fetching the POIs',
            updateCheckpoint: 'An error occured while updating the POI {name}'
        },
        success: {
            createCheckpoint: 'POI {name} successfully created !',
            deleteCheckpoint: 'POI {name} successfully deleted !',
            fetchCheckpoint: 'POI successfully fetched',
            fetchCheckpoints: 'POIs successfully fetched',
            updateCheckpoint: 'POI {name} successfully edited !'
        }
    },
    buttons: {
        showAll: 'Show all POIS',
        hideAll: 'Hide additional POIS'
    },

    model: {
        associates: 'Associated devices',
        comments: 'Comment',
        name: 'POI name'
    },
    detail: {
        associates: 'Associate a device',
        associateDevice: 'Associate device',
        noDeviceAssociated: 'No device associated',
        dissociateDevice: 'Dissociate device'
    },
    title: {
        informationsTitle: 'Information',
        associateDeviceTitle: 'Associate devices',
        partnerTitle: "Partner's information",
        actionsTitle: 'Actions'
    }
}
